import { EntityMediaFragment } from '@/features/messages/graphql/fragments/generated/MediaType';

export enum FormSection {
  Basic = 'BASIC',
  Submissions = 'SUBMISSIONS',
  Questions = 'QUESTIONS',
  Reviewer = 'REVIEWER',
  Skills = 'SKILLS',
  Certificate = 'CERTIFICATE',
  Tags = 'TAGS',
  NativeSettings = 'NATIVE_SETTINGS',
  Manage = 'MANAGE',
  WorkspaceSettings = 'WORKSPACE_SETTINGS',
  AssignmentRestriction = 'ASSIGNMENT_RESTRICTION',
}

export interface Section {
  i18Key: string;
  sectionKey: string;
  Icon: (props: { className: string }) => JSX.Element;
  hasError?: boolean;
}

export interface InstructionsMediaProps {
  value: EntityMediaFragment[];
  onChange: (media: EntityMediaFragment[]) => void;
}

export interface RadioOption {
  label: string;
  value: string;
  description: string;
  Icon: (props: { className?: string }) => JSX.Element;
}
